import { render, staticRenderFns } from "./PJOffers.vue?vue&type=template&id=31d23556"
import script from "./PJOffers.vue?vue&type=script&lang=js"
export * from "./PJOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports